import { AutomationsPresentationV1Edge } from '../../types'

/**
 * Collect the ids of all nodes reachable from `startId` by walking edges in a
 * direction, inclusive of `startId`. `downstream` follows edges source→target
 * (descendants); `upstream` follows target→source (ancestors). Cycle-safe.
 */
export const collectReachableNodeIds = ({
  startId,
  edges,
  direction
}: {
  startId: string
  edges: AutomationsPresentationV1Edge[]
  direction: 'upstream' | 'downstream'
}): Set<string> => {
  const visit = (id: string, visited: Set<string>): Set<string> => {
    if (visited.has(id)) return visited

    const seen = new Set(visited).add(id)

    const neighbourIds = edges.reduce<string[]>((acc, edge) => {
      if (direction === 'downstream' && edge.source === id) {
        return [...acc, edge.target]
      }
      if (direction === 'upstream' && edge.target === id) {
        return [...acc, edge.source]
      }
      return acc
    }, [])

    return neighbourIds.reduce(
      (acc, neighbourId) => visit(neighbourId, acc),
      seen
    )
  }

  return visit(startId, new Set<string>())
}
